import templates from 'src/templates/redirect';
import domSelector from 'src/utils/domSelector';
import DOM_SELECTOR_CONFIG from 'src/config/domSelectorConfig';
import View from 'src/components/shared/view';

const SELECTORS = {
  dataView: DOM_SELECTOR_CONFIG.REDIRECT_DATA_SELECTORS.REDIRECT_VIEW
};

export default class RedirectView extends View {
  render(options) {
    const template = this.optionHandlers.template(templates, options);
    this.destroy();
    this.appendToBody(template(SELECTORS));
    this.redirectContainer = domSelector.getRedirectContainer();
  }

  destroy() {
    this.redirectContainer = null;
    super.destroy();
  }
}
